
/*eslint-disable*/
import { BodyText, TitleText } from 'styling/Typography'
import { AIChatContainer, AIChatHistory, AIChatHistoryItem, AIChatQuestion, AIChatResponse, AICurrentChat, AskAiButton, AskAiContainer } from './GlobalView.styled'
import { SmallAimIcon } from 'assets/icons/SmallAimIcon'
import { useEffect, useRef, useState } from 'react'
import { PaperPlaneIcon } from 'assets/icons/PaperPlaneIcon'
import { EventSource } from 'eventsource'
import { fetchAuthSession } from 'aws-amplify/auth'
import { IGLAIResponse, IGLMessage } from 'types/global-view.interface'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { getAIChats, getChatMessages } from 'features/globalView/globalViewSlice'
import { IAIChatMessagesSingleReponse } from 'types/api/globalViewApi.interface'
import { ChatLoader } from 'pages/Shifts/Shifts.styled'
import { Flex } from 'styling/GlobalStyles'

export const AskAI = () => {
    const [open, setOpen] = useState(false)
    const inputRef = useRef(null)
    const [messages, setMessages] = useState<IGLMessage[]>([]);
    const eventSourceRef = useRef(null);
    const chatRef = useRef(null)
    const containerRef = useRef(null)
    const [text, setText] = useState<string>('')
    const [isConnected, setIsConnected] = useState(false);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(process.env.REACT_APP_API + '/assistant/chat/message/stream?message=');
    const [chatId, setChatId] = useState(null)
    const { chats } = useSelector((store: RootState) => store.globalView)
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(getAIChats({ limit: 99, page: 1 }))
    }, [])

    useEffect(() => {
        inputRef?.current?.focus()
    }, [open])

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages])

    useEffect(() => {
        const outSideClick = (e) => {
            if (!containerRef.current.contains(e.target)) {
                setOpen(false)
                setChatId(null)
                setMessages([])
            }
        }

        document.addEventListener('mousedown', outSideClick)

        return () => {
            document.removeEventListener('mousedown', outSideClick)
        }
    }, [])

    const handleOpen = () => {
        setOpen(true)
    }

    const handleMessage = (q: string, a: IGLAIResponse) => {
        if (q) {
            setMessages(prev => [...prev, { type: 'question', data: q }])
        } else {
            setMessages(prev => {
                const copy = structuredClone(prev)
                if (a?.type == 2) {
                    const index = copy.findIndex((message) => message.type === 'answer' && message.id === a.messageChunk.id);
                    if (index > -1) {
                        copy[index].data = copy[index].data + a.messageChunk.chunk
                    } else {
                        copy.push({ type: 'answer', data: a.messageChunk.chunk, id: a.messageChunk.id })
                    }
                } else {
                    setChatId(a.chat.id)
                }

                return copy
            })
        }
    }



    const handleConnect = async () => {

        if (!url) {
            setError('Please enter a valid URL');
            return;
        }

        try {
            if (eventSourceRef.current) {
                eventSourceRef.current.close();
            }

            const session = await fetchAuthSession()
            const eventSource = new EventSource((url + text) + (chatId ? ('&chatId=' + chatId) : ''), {
                fetch: (input, init) =>
                    fetch(input, {
                        ...init,
                        headers: {
                            ...init.headers,
                            Authorization: `Bearer ${session.tokens.accessToken.toString()}`,
                        },
                    }),
            });
            eventSourceRef.current = eventSource;

            eventSource.onopen = () => {
                setIsConnected(true);
                setError(null);
                setEvents(prev => [...prev, { type: 'connection', data: 'Connection established', timestamp: new Date().toISOString() }]);
            };

            // Handle messages
            eventSource.onmessage = (event) => {
                handleMessage(null, JSON.parse(event.data))
            };

            // Handle errors
            eventSource.onerror = (err) => {
                setError(`Connection error: ${err.message || 'Unknown error'}`);
                setIsConnected(false);
                eventSource.close();
                eventSourceRef.current = null;
            };

        } catch (err) {
            setError(`Failed to connect: ${err.message}`);
        }
    };

    const handleDisconnect = async () => {
        if (eventSourceRef.current) {
            await eventSourceRef.current.close();
            eventSourceRef.current = null;
            setIsConnected(false);
            setEvents(prev => [...prev, { type: 'connection', data: 'Connection closed', timestamp: new Date().toISOString() }]);
        }
    };

    const handleSendMessage = async () => {
        if (text) {
            await handleConnect()
            handleMessage(text, null)
            setText('')
        }


    }



    const openChat = async (id: number) => {
        await handleDisconnect()
        await dispatch(getChatMessages({ limit: 99, id, lastMessageId: null })).then((res) => {
            setMessages((res.payload as IAIChatMessagesSingleReponse[]).map((message) => {
                if (message.role === 2) {
                    return { type: 'question', data: message.text }
                } else {
                    return { type: 'answer', data: message.text, id: message.id }
                }
            }
            ))
        })
        setChatId(id)
    }
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };
    return (
        <AskAiContainer ref={containerRef} >
            <AIChatContainer open={open}>
                <AIChatHistory>
                    {chats.map(c => <AIChatHistoryItem onClick={() => openChat(c.id)} key={c.id} color='white' ><p>{c.name}</p></AIChatHistoryItem>)}
                </AIChatHistory>
                <AICurrentChat ref={chatRef} >
                    {messages.map((message, index) =>
                        message.type === 'question' ? <>
                            <AIChatQuestion key={index} className={message.type}>
                                <div className='content' >
                                    <BodyText dangerouslySetInnerHTML={{ __html: message.data.replace(/\n/g, "<br />") }} />
                                </div>

                            </AIChatQuestion></> : <>
                            <AIChatResponse key={index} className={message.type}>
                                <BodyText>
                                    {message.data}
                                </BodyText>
                            </AIChatResponse>
                        </>
                    )}
                    {messages[messages.length - 1]?.type == 'question' && <Flex width='100%' ><ChatLoader /></Flex>}
                </AICurrentChat>

            </AIChatContainer>
            <AskAiButton width={open ? '400px' : '170px'} onClick={handleOpen}>
                {open ? (
                    <Flex width='100%' gap='1rem'   >
                        <input onKeyDown={handleKeyDown} onChange={e => setText(e.target.value)} value={text} onClick={e => e.stopPropagation()} ref={inputRef} placeholder='Ask AI' />
                        <PaperPlaneIcon onClick={handleSendMessage} />
                    </Flex>
                ) : (
                    <>
                        <TitleText style={{ marginRight: '10px' }} weight='bold'>
                            Ask
                        </TitleText>
                        <SmallAimIcon />
                    </>
                )}
            </AskAiButton>
        </AskAiContainer>
    )
}
